import request from 'utils/RequestManager';
import config from 'config';

const authURL = config.AUTH_HOST;
const backendURL = config.BACKEND_HOST;

export function authenticate(username, password) {
    return request({
        method: 'post',
        baseURL: authURL,
        url: '/login',
        data: {
            username,
            password,
        },
    });
}

export function logOperatorSession({operatorPlatformId, parentCompanyId, actionType, userAgent}) {
    return request({
        method: 'post',
        baseURL: backendURL,
        url: '/operator-session',
        params: {
            operatorPlatformId,
            parentCompanyId,
            actionType,
            'User-Agent': userAgent || navigator.userAgent,
        },
    });
}

export function verifyToken(token) {
    return request({
        method: 'post',
        baseURL: authURL,
        url: `valid/${token}`,
    });
}

export function resetPasswordClick(email) {
    return request({
        method: 'post',
        baseURL: authURL,
        url: `reset`,
        params: {email},
    });
}

export function register(registerData, token) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/confirm/${token}`,
        data: registerData,
    });
}

export function reset(resetPasswordData, token) {
    return request({
        method: 'PUT',
        baseURL: authURL,
        url: `/reset/${token}`,
        data: resetPasswordData,
    });
}

export function fetchUser(id) {
    return request({
        method: 'GET',
        baseURL: authURL,
        url: '/users',
        params: {
            id,
        },
    }).then(response => response.data);
}

export function fetchUserSystemNotifications() {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/user-system-notification',
    }).then(response => response.data);
}

export function deleteUserSystemNotification(userSystemNotificationId) {
    return request({
        method: 'DELETE',
        baseURL: backendURL,
        url: '/user-system-notification/' + userSystemNotificationId,
    }).then(response => response.data);
}

export function deleteUserSystemNotifications() {
    return request({
        method: 'DELETE',
        baseURL: backendURL,
        url: '/user-system-notification/all',
    }).then(response => response.data);
}

export function markUserSystemNotificationAsRead(userSystemNotificationId) {
    return request({
        method: 'PUT',
        baseURL: backendURL,
        url: '/user-system-notification/' + userSystemNotificationId,
    }).then(response => response.data);
}

export function markUserSystemNotificationsAsRead() {
    return request({
        method: 'PUT',
        baseURL: backendURL,
        url: '/user-system-notification/all',
    }).then(response => response.data);
}

export function updateUser(userInfo) {
    return request({
        method: 'PATCH',
        baseURL: authURL,
        url: '/user/profile/main-info',
        data: userInfo,
    }).then(response => response.data);
}

export function changePassword(userInfo) {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/user/profile/password',
        data: userInfo,
    }).then(response => response.data);
}

export function updateLocale(locale) {
    return request({
        method: 'PATCH',
        baseURL: authURL,
        url: '/user/profile/locale',
        data: {locale}
    }).then(response => response.data);
}

export function logOutUser() {
    return request({
        method: 'POST',
        baseURL: authURL,
        url: '/logout',
    }).then(response => response);
}



// WEBPACK FOOTER //
// ./src/services/user/api.js